import { render, staticRenderFns } from "./NotamObserverView.vue?vue&type=template&id=3a9f2c3a"
import script from "./NotamObserverView.vue?vue&type=script&lang=js"
export * from "./NotamObserverView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports